import type { ReactNode } from 'react'
import type { Capability } from '@/api/schema'
import { ErrorState } from '@/components/feedback/ErrorState'
import { LoadingState } from '@/components/feedback/LoadingState'
import { ForbiddenPage } from '@/app/pages/ForbiddenPage'
import { usePermissions } from './permissions'

interface RequirePermissionProps {
  permission?: Capability | Capability[]
  children: ReactNode
}

/** Guarda de rota: mostra a página 403 sem a capability. Apenas UX (o backend é a autoridade). */
export function RequirePermission({ permission, children }: RequirePermissionProps) {
  const permissions = usePermissions()
  if (!permission) return <>{children}</>
  if (permissions.isLoading) return <LoadingState label="Verificando permissões…" />
  if (permissions.error) return <ErrorState error={permissions.error} />
  if (!permissions.can(permission)) {
    return <ForbiddenPage permission={Array.isArray(permission) ? permission : [permission]} />
  }
  return <>{children}</>
}
